import * as React from 'react'
import { withFormik } from 'formik'
import onClickOutside from 'react-onclickoutside'

const Yup = require('yup')

import { Button } from '../../../../../../common/Button/Button'
import Checkbox from '../../../../../../common/Checkbox/Checkbox'
import { get } from 'lodash'
import { Dropdown } from '../../../../../../common/Dropdown/Dropdown'
import FetchSearchSelect from '../../../../../../common/FetchSearchSelect/FetchSearchSelect'
import DateInput from '../../../../../../common/DateInput'

var EnhancedComponent = onClickOutside(Dropdown)
var EnhancedSearchComponent = onClickOutside(FetchSearchSelect)

const listOptions: any = [{ value: '', text: 'Not listed' },
{ value: '1', text: 'Grade 1' },
{ value: '2', text: 'Grade 2' },
{ value: '2*', text: 'Grade 2 *' },
{ value: 'A', text: 'Grade A' },
{ value: 'B', text: 'Grade B' }]

const basementOptions: any = [{ value: '', text: 'No basement' },
{ value: 'Residential', text: 'Residential' },
{ value: 'Commercial', text: 'Commercial' },
{ value: 'Storage', text: 'Storage' }]

const percentageOptions: any = [{ value: '', text: '0%' },
{ value: 15, text: '1-15%' },
{ value: 25, text: '16-25%' },
{ value: 50, text: '26-50%' },
{ value: 100, text: '51+%' }]

const constructionOptions: any = [{ value: '', text: 'None' },
{ value: 'Wooden', text: 'Wooden' },
{ value: 'Concrete', text: 'Concrete' },
{ value: 'Other', text: 'Other' }]

const monthOptions: any = [
    { value: 12, text: '12 months' },
    { value: 24, text: '24 months' },
    { value: 36, text: '36 months' }]

const purelyCommercial: any = [
    'House', 'Multiple flats (Converted house)', 'Multiple flats (Purpose built)', 'Individual flat', 'Bed-sits', 'HMO']
const purelyResidential: any = ['Shop', 'Office', 'Restaurant', 'Takeaway', 'Industrial unit', 'Warehouse']

class AddressSecurityForm extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            toggle: false,
            showAlarmDetails: true,
            propertyList: [],
            residentialList: [],
            commercialList: [],
            occupancyType: '',
            commericalDisable: false,
            residentialDisable: false,
            values: props.propertyData,
            floorError: false,
        }
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, prevContext: any): void {
        const { occupancyType } = this.state
        const { occupancies = [] } = this.props

        if (prevProps.occupancies !== occupancies) {
            let newState = {}

            switch (occupancyType) {
                case 'Property type':
                    newState = {
                        propertyList: [
                            { 'id': '', 'hcc': '', 'hiscox': '', 'occupanyType': '', 'title': 'None' }, ...occupancies],
                    }
                    break
                case 'Residential occupancy':
                    newState = {
                        residentialList: [
                            { 'id': '', 'hcc': '', 'hiscox': '', 'occupanyType': '', 'title': 'None' }, ...occupancies],
                    }
                    break
                default:
                    newState = {
                        commercialList: [
                            { 'id': '', 'hcc': '', 'hiscox': '', 'occupanyType': '', 'title': 'None' }, ...occupancies],
                    }
                    break
            }

            if (JSON.stringify(newState) !== JSON.stringify(this.state)) {
                this.setState(newState)
            }
        }
    }

    addressChange = (field: any, value: any) => {
        this.props.setFieldTouched(field, true)
        this.props.setFieldValue(field, value)
    }

    toggleCheckBox = (state: any, field: any) => {
        this.setState({ toggle: state })
    }

    handleChangeCustom = (state: any, field: any) => {
        this.props.setFieldTouched(field, true)
        this.props.setFieldValue(field, state)

        if (field === 'concreteFloors' || field === 'timberFloors') {
            this.setState({ floorError: true })
        }
    }

    handleChange = (field: any, value: any) => {
        this.props.setFieldTouched(field, true)
        this.props.setFieldValue(field, value)
        if (field === 'propertyType') {
            this.setNoneOptions(value)
        }
    }

    handleCancel = () => {
        this.props.handleCancel()
    }

    fetchOccupancies = async (occupancyType: string, query: string, sortOrder: any) => {
        const { values } = this.state
        this.setState({ occupancyType })
        const response = await this.props.fetchOccupancies(occupancyType, query, sortOrder)
        if (response && response.value) {
            const list: any = [
                { 'id': '', 'hcc': '', 'hiscox': '', 'occupanyType': '', 'title': 'None' }, ...response.value]
            if (occupancyType === 'Property type') {
                this.setState({ propertyList: list }, () => {
                    if (occupancyType === 'Property type') {
                        this.setNoneOptions(get(values, 'propertyType', ''))
                    }
                })
            } else if (occupancyType === 'Residential occupancy') {
                this.setState({ residentialList: list })
            } else {
                this.setState({ commercialList: list })
            }
        }
    }

    focusChange(event: any) {
        if (event.target.classList.contains('calendar__input')) {
            event.target.parentNode.parentNode.previousSibling.classList = 'active'
        } else {
            event.target.previousSibling.classList = 'active'
        }
    }

    getSelectedValue = (list, fieldName, fieldAry = ['value', 'text']) => {
        const { values = {} } = this.props
        const val = get(values, fieldName, '')
        if (list.length > 0) {
            if (val) {
                const item = list.find(option => ((option[fieldAry[0]]).toString()) === (val.toString()))
                if (item) {
                    return [(item[fieldAry[0]]), (item[fieldAry[1]])]
                }
            } else {
                return [list[0][fieldAry[0]], list[0][fieldAry[1]]]
            }
        }

        return ['', '']
    }

    getSelectedTitle = (list, fieldName) => {
        const { values = {} } = this.props
        const val = get(values, fieldName, '')
        if (val && list.length > 0) {
            const item = list.find(option => ((option.id).toString()) === (val.toString()))
            if (item) {
                return item.title
            }
        }
        return ''
    }

    setNoneOptions = (propertyType: any) => {
        const { propertyList } = this.state

        const item = propertyType ? propertyList.find(option => option.id.toString() === propertyType.toString()) : ''
        const isCommercial = item && purelyCommercial.includes(item.title)
        const isResidential = item && purelyResidential.includes(item.title)

        if (isCommercial) {
            this.props.setFieldValue('commercialOccupancy', '')
        }

        if (isResidential) {
            this.props.setFieldValue('residentialOccupancy', '')
        }

        if (item && ['Shops with flat(s) above', 'Office with flat(s) above'].includes(item.title)) {
            this.props.setFieldValue('bothOccupancy', true)
        } else {
            this.props.setFieldValue('bothOccupancy', false)
        }
        if (item && ['Other'].includes(item.title)) {
            this.props.setFieldValue('otherPropertyType', true)
        } else {
            this.props.setFieldValue('otherPropertyType', false)
        }

        this.setState({
            commericalDisable: !!isCommercial,
            residentialDisable: !!isResidential,
        })
    }

    render() {

        const { values = {}, errors: { sumOfConcreteWood = '' }, isValid = true } = this.props
        const { propertyList, residentialList, commercialList, commericalDisable, residentialDisable, floorError } =
            this.state

        const heatingOptions = [
            'low pressure hot water or steam',
            'oil fired space heaters fed from a fuel tank in the open',
            'overhead gas or electrical appliances',
            'gas or electric fires in offices only or as expressly varied in accordance with details provided to Us',
        ]

        return (
            <div className="addressBlock__content">
                {(get(this.props, 'address.riskLocation') || get(this.props, 'propertyData.addressLine1')) ? (
                    <div className="addressBlock__addressBar">
                        {get(this.props, 'address.riskLocation.addressLine1', '') ||
                            get(this.props, 'propertyData.addressLine1', '')},
                        {get(this.props, 'address.riskLocation.addressLine2', '') ||
                            get(this.props, 'propertyData.addressLine2', '')},
                        {get(this.props, 'address.riskLocation.city', '') ||
                            get(this.props, 'propertyData.city', '')},
                        {get(this.props, 'address.riskLocation.postcode', '') ||
                            get(this.props, 'propertyData.postcode', '')}
                    </div>
                ) : null}
                <form onSubmit={this.props.handleSubmit}>
                    <div className="pad_left_right">
                        <h4 className="form__w40">Security details</h4>
                        <div className="quote__form__group form__w60">
                            <Checkbox
                                onChange={this.toggleCheckBox}
                                short={true}
                                first={true}
                                last={true}
                                name="toggle"
                            >
                                Confirm all the below
                            </Checkbox>
                        </div>

                        <div className="quote__form__group form__w100">
                            <Checkbox
                                onChange={this.handleChangeCustom}
                                first={true}
                                name="goodState"
                                selectAll={this.state.toggle}
                                selected={get(values, 'goodState', false)}
                            >
                                Property is of a good state of repair.
                            </Checkbox>

                            <Checkbox
                                onChange={this.handleChangeCustom}
                                first={true}
                                name="notUndergo"
                                selectAll={this.state.toggle}
                                selected={get(values, 'notUndergo', false)}
                            >
                                Not undergoing or planning to undergo building works
                            </Checkbox>

                            <Checkbox
                                onChange={this.handleChangeCustom}
                                name="notUniccupied"
                                selectAll={this.state.toggle}
                                selected={get(values, 'notUniccupied', false)}
                            >
                                Occupied within 45 days of inception
                            </Checkbox>

                            <Checkbox
                                onChange={this.handleChangeCustom}
                                name="subsidence"
                                selectAll={this.state.toggle}
                                selected={get(values, 'subsidence', false)}
                            >
                                The property has never had or shown signs of subsidence
                            </Checkbox>
                            <Checkbox
                                onChange={this.handleChangeCustom}
                                name="sufferedFlooding"
                                selectAll={this.state.toggle}
                                selected={get(values, 'sufferedFlooding', false)}
                            >
                                The property has never suffered from or is within 400 yards of an area that has
                                previously suffered flooding
                            </Checkbox>
                            <Checkbox
                                onChange={this.handleChangeCustom}
                                name="hmo"
                                selectAll={this.state.toggle}
                                selected={get(values, 'hmo', false)}
                            >
                                No part of the property is an HMO
                            </Checkbox>
                        </div>

                        <h4 className="form__w100">Construction</h4>
                        <div className="quote__form__group form__w100">
                            <Checkbox
                                onChange={this.handleChangeCustom}
                                first={true}
                                name="brickStoneConcrete"
                                selected={get(values, 'brickStoneConcrete', false)}
                            >
                                Constructed of brick, stone or concrete
                            </Checkbox>

                            <Checkbox
                                onChange={this.handleChangeCustom}
                                name="notBuiltRoofSlateTileMetal"
                                selected={get(values, 'notBuiltRoofSlateTileMetal', false)}
                            >
                                Roofed with slates, tiles, concrete, metal or asbestos or flat roof area as detailed
                                below
                            </Checkbox>

                            <Checkbox
                                onChange={this.handleChangeCustom}
                                last={true}
                                name="heatedBy"
                                selected={get(values, 'heatedBy', false)}
                            >
                                Heated by:
                                <ul>
                                    {heatingOptions.map((option, index) => (
                                        <li key={index}>{option}</li>
                                    ))}
                                </ul>
                            </Checkbox>
                        </div>
                        <div className="property_sec property_about_sec">
                            <div className="property_group">
                                <div className="title">
                                    <h3 className="property_h3">About the property</h3>
                                </div>
                                <div className="item-col-2 item-col-2__w58 sec_1">
                                    <div className="col1">
                                        <label className="label_sec">Year of build</label>
                                        <div
                                            className={`input input__no-symbol`}
                                            style={{
                                                border: (get(values, 'yearOfBuild') <= 0) ? '1px solid red' : '',
                                            }}
                                        >
                                            <DateInput
                                                guide={false}
                                                placeholder="YYYY"
                                                defaultMask={[/\d/, /\d/, /\d/, /\d/]}
                                                onChange={(year) => {
                                                    const currentYear = new Date().getFullYear()
                                                    const yearValue = parseInt(year, 10)
                                                    if (yearValue <= currentYear) {
                                                        this.handleChangeCustom(
                                                            Number(year), 'yearOfBuild')
                                                    } else {
                                                        this.handleChangeCustom(
                                                            '', 'yearOfBuild')
                                                    }
                                                }}
                                                showIcon={false}
                                                value={get(values, 'yearOfBuild', '')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col2">
                                        <label className="label_sec">Listed status</label>
                                        <div className="">
                                            <EnhancedComponent
                                                itemList={listOptions}
                                                name="listed"
                                                setFieldValue={this.handleChange}
                                                check={true}
                                                label="Not listed"
                                                labelShow={false}
                                                selected={this.getSelectedValue(listOptions, 'listed')}
                                            />
                                        </div>

                                    </div>
                                </div>
                                <div className="item-col-2 item-col-2__w58">
                                    <div className="col1">
                                        <label className="label_sec">Basement use</label>
                                        <div className="">
                                            <EnhancedComponent
                                                itemList={basementOptions}
                                                name="basementUse"
                                                setFieldValue={this.handleChange}
                                                check={true}
                                                label="Choose basement"
                                                labelShow={false}
                                                selected={this.getSelectedValue(basementOptions, 'basementUse')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col2">
                                        <label className="label_sec">Total number of floors, including basement</label>
                                        <div
                                            className={`input input__no-symbol`}
                                            style={{
                                                border: (get(values, 'totalFloorBasement') <= 0) ? '1px solid red' : '',
                                            }}
                                        >
                                            <input
                                                name="totalFloorBasement"
                                                onChange={
                                                    (event) => {
                                                        const floorBaseValue =
                                                            event.target.value.replace(/[^0-9]/g, '')
                                                        this.handleChangeCustom(
                                                            Number(floorBaseValue), 'totalFloorBasement')
                                                    }
                                                }
                                                placeholder="0"
                                                type="text"
                                                min="0"
                                                step="any"
                                                value={
                                                    Number(get(values, 'totalFloorBasement', 0)).toLocaleString('en-GB')
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="item-col-2 item-col-2__w58">
                                    <div className="col1">
                                        <label className="label_sec">Number of concrete floors</label>
                                        <div
                                            className={`input input__no-symbol`}
                                            style={{
                                                border: (get(values, 'concreteFloors') <= 0 &&
                                                    get(values, 'timberFloors') <= 0) ||
                                                    (get(values, 'totalFloorBasement') !==
                                                        (get(values, 'concreteFloors') + get(values, 'timberFloors'))) ?
                                                    '1px solid red' : '',
                                            }}
                                        >
                                            <input
                                                name="concreteFloors"
                                                onChange={
                                                    (event) => {
                                                        const concreteValue =
                                                            event.target.value.replace(/[^0-9]/g, '')
                                                        this.handleChangeCustom(
                                                            Number(concreteValue), 'concreteFloors')
                                                    }
                                                }
                                                placeholder="0"
                                                type="text"
                                                min="0"
                                                step="any"
                                                value={
                                                    Number(get(values, 'concreteFloors', 0)).toLocaleString('en-GB')
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col2">
                                        <label className="label_sec">Number of timber floors</label>
                                        <div
                                            className={`input input__no-symbol`}
                                            style={{
                                                border: (get(values, 'concreteFloors') <= 0 &&
                                                    get(values, 'timberFloors') <= 0) ||
                                                    ((get(values, 'totalFloorBasement')) !==
                                                        (get(values, 'concreteFloors') +
                                                            get(values, 'timberFloors'))) ?
                                                    '1px solid red' : '',
                                            }}
                                        >
                                            <input
                                                name="timberFloors"
                                                onChange={
                                                    (event) => {
                                                        const timberFloorsValue =
                                                            event.target.value.replace(/[^0-9]/g, '')
                                                        this.handleChangeCustom(
                                                            Number(timberFloorsValue), 'timberFloors')
                                                    }
                                                }
                                                placeholder="0"
                                                type="text"
                                                min="0"
                                                step="any"
                                                value={
                                                    Number(get(values, 'timberFloors', 0)).toLocaleString('en-GB')
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                {floorError && sumOfConcreteWood && !isValid && (
                                    <span className="floor_error">{sumOfConcreteWood}</span>)}
                                <div className="item-col-2 item-col-2__w58">
                                    <div className="col1">
                                        <label className="label_sec">Percentage of flat roof</label>
                                        <div className="">
                                            <EnhancedComponent
                                                itemList={percentageOptions}
                                                name="percentageOfFlatRoof"
                                                setFieldValue={this.handleChange}
                                                check={true}
                                                label="0%"
                                                labelShow={false}
                                                selected={
                                                    this.getSelectedValue(percentageOptions, 'percentageOfFlatRoof')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col2">
                                        <label className="label_sec">Construction of flat roof</label>
                                        <div className="">
                                            <EnhancedComponent
                                                style={{
                                                    border: (get(values, 'percentageOfFlatRoof') > 0 &&
                                                        get(values, 'constructionFlatRoof') === '')
                                                        ? '1px solid red'
                                                        : '',
                                                }}
                                                itemList={constructionOptions}
                                                name="constructionFlatRoof"
                                                setFieldValue={this.handleChange}
                                                check={true}
                                                label="Choose construction of flat roof"
                                                labelShow={false}
                                                selected={
                                                    this.getSelectedValue(constructionOptions, 'constructionFlatRoof')}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="property_sec">
                            <div className="property_group">
                                <div className="title">
                                    <h3 className="property_h3">Property use</h3>
                                </div>
                                <div className="item-col-2 item-col-2__w58 sec_1">
                                    <div className="col1">
                                        <label className="label_sec">Property type</label>
                                        <div className="">
                                            <EnhancedSearchComponent
                                                style={{
                                                    border: get(values, 'propertyType') === ''
                                                        ? '1px solid red'
                                                        : '1px solid #cfd8dd',
                                                }}
                                                name="propertyType"
                                                setFieldValue={this.handleChange}
                                                occupancyType="Property type"
                                                label="None"
                                                labelShow={false}
                                                searchPlaceholder={'search...'}
                                                customCls={'cp_search_dropdown'}
                                                fetchOccupancies={this.fetchOccupancies}
                                                itemList={propertyList}
                                                sortOrder={'asc'}
                                                selected={
                                                    this.getSelectedTitle(propertyList, 'propertyType')
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col2">
                                        <label className="label_sec">Nature of commercial occupancy</label>
                                        <div className="">
                                            <EnhancedSearchComponent
                                                style={{
                                                    border:
                                                        get(values, 'bothOccupancy') === true &&
                                                            get(values, 'commercialOccupancy') === '' ||
                                                            (!commericalDisable && residentialDisable &&
                                                                get(values, 'commercialOccupancy') === '') ||
                                                            get(values, 'otherPropertyType') === true &&
                                                            (get(values, 'commercialOccupancy') === '' &&
                                                                get(values, 'residentialOccupancy') === '')
                                                            ? '1px solid red'
                                                            : '',
                                                }}
                                                name="commercialOccupancy"
                                                setFieldValue={this.handleChange}
                                                occupancyType="Commercial occupancy"
                                                label="None"
                                                labelShow={false}
                                                searchPlaceholder={'search...'}
                                                customCls={'cp_search_dropdown'}
                                                fetchOccupancies={this.fetchOccupancies}
                                                itemList={commercialList}
                                                sortOrder={'asc'}
                                                disable={commericalDisable}
                                                selected={
                                                    this.getSelectedTitle(commercialList, 'commercialOccupancy')}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="item-col-2 item-col-2__w58">
                                    <div className="col1">
                                        <label className="label_sec">Nature of residential occupancy</label>
                                        <div className="">
                                            <EnhancedSearchComponent
                                                style={{
                                                    border:
                                                        get(values, 'bothOccupancy') === true &&
                                                            get(values, 'residentialOccupancy') === '' ||
                                                            (!residentialDisable && commericalDisable &&
                                                                get(values, 'residentialOccupancy') === '') ||
                                                            get(values, 'otherPropertyType') === true &&
                                                            (get(values, 'commercialOccupancy') === '' &&
                                                                get(values, 'residentialOccupancy') === '')
                                                            ? '1px solid red'
                                                            : '',
                                                }}
                                                name="residentialOccupancy"
                                                setFieldValue={this.handleChange}
                                                occupancyType="Residential occupancy"
                                                label="None"
                                                labelShow={false}
                                                searchPlaceholder={'search...'}
                                                customCls={'cp_search_dropdown'}
                                                fetchOccupancies={this.fetchOccupancies}
                                                itemList={residentialList}
                                                sortOrder={'asc'}
                                                disable={residentialDisable}
                                                selected={
                                                    this.getSelectedTitle(residentialList, 'residentialOccupancy')}
                                            />
                                        </div>
                                    </div>
                                    <div className="col2">
                                        <label className="label_sec">Number of flats</label>
                                        <div className="">
                                            <div className={`input input__no-symbol`}>
                                                <input
                                                    name="noOfFlats"
                                                    onChange={
                                                        (event) => {
                                                            const flatsdValue =
                                                                event.target.value.replace(/[^0-9]/g, '')
                                                            this.handleChangeCustom(
                                                                Number(flatsdValue), 'noOfFlats')
                                                        }
                                                    }
                                                    placeholder="0"
                                                    type="text"
                                                    min="0"
                                                    step="any"
                                                    value={Number(get(values, 'noOfFlats', 0)).toLocaleString('en-GB')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="extra_cover_sec">
                            <div className="extra_cover_group">
                                <div className="title">
                                    <h3 className="cover_h3">Sums insured required</h3>
                                </div>
                                {/* <div className="item-col-2 item-col-2__w58 item-col-2 item-col-2__title-name">
                                    <div className="col1">
                                        <span>Type of cover</span>
                                    </div>
                                    <div className="col2">
                                        <span>Sum insured</span>
                                    </div>
                                </div> */}
                                <div className="item-col-2 item-col-2__w58 bottom-line">
                                    <div className="col1 col1__checkbox">
                                        <Checkbox
                                            last={true}
                                            first={true}
                                            short={true}
                                            name="contentsOnly"
                                            selected={get(values, 'contentsOnly', false)}
                                            onChange={this.handleChangeCustom}
                                        >
                                            Contents only
                                        </Checkbox>
                                    </div>
                                </div>
                                <div className="item-col-2 item-col-2__w58 bottom-line">
                                    <div className="col1 col1__checkbox">
                                        <div className="build_value">Building declared value</div>
                                    </div>
                                    <div className="col2">
                                        <div
                                            className={`input`}
                                            style={{
                                                border: (get(values, 'declared') <= 0 &&
                                                    get(values, 'contentsOnly') === false) ? '1px solid red' : '',
                                            }}
                                        >
                                            <div className="pound">
                                                &pound;
                                            </div>
                                            <input
                                                name="declared"
                                                onChange={
                                                    (event) => {
                                                        const declaredValue = event.target.value.replace(/[^0-9]/g, '')
                                                        this.handleChangeCustom(
                                                            Number(declaredValue), 'declared')
                                                    }
                                                }
                                                placeholder="0"
                                                type="text"
                                                min="0"
                                                step="any"
                                                value={Number(get(values, 'declared', 0)).toLocaleString('en-GB')}
                                            />
                                        </div>

                                    </div>
                                </div>
                                <div className="item-col-2 item-col-2__w58 bottom-line">
                                    <div className="col1 col1__checkbox">
                                        <Checkbox
                                            last={true}
                                            first={true}
                                            short={true}
                                            name="landLordCheck"
                                            selected={get(values, 'landLordCheck', false)}
                                            onChange={this.handleChangeCustom}
                                        >
                                            Landlord contents
                                        </Checkbox>
                                    </div>
                                    <div className="col2">
                                        <div
                                            className={`input ${get(values, 'landLordCheck', false) ? '' : 'disabled'}`}
                                            style={{
                                                border: (get(values, 'landLord') <= 0 &&
                                                    get(values, 'contentsOnly') === true) ? '1px solid red' : '',
                                            }}
                                            onClick={() => {
                                                this.handleChangeCustom(
                                                    true, 'landLordCheck')
                                            }}
                                        >
                                            <div className="pound">
                                                &pound;
                                            </div>
                                            <input
                                                name="landLord"
                                                disabled={!get(values, 'landLordCheck', false)}
                                                onChange={
                                                    (event) => {
                                                        const landValue = event.target.value.replace(/[^0-9]/g, '')
                                                        this.handleChangeCustom(
                                                            Number(landValue), 'landLord')
                                                    }
                                                }
                                                placeholder="0"
                                                type="text"
                                                min="0"
                                                step="any"
                                                value={Number(get(values, 'landLord', 0)).toLocaleString('en-GB')}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="item-col-2 item-col-2__w58 bottom-line">
                                    <div className="col1 col1__checkbox">
                                        <Checkbox
                                            last={true}
                                            first={true}
                                            short={true}
                                            name="commonAreaCheck"
                                            selected={get(values, 'commonAreaCheck', false)}
                                            onChange={this.handleChangeCustom}
                                        >
                                            Contents of common areas
                                        </Checkbox>
                                    </div>
                                    <div className="col2">
                                        <div
                                            className={`input 
                                                ${get(values, 'commonAreaCheck', false) ? '' : 'disabled'}`}
                                            onClick={() => {
                                                this.handleChangeCustom(true, 'commonAreaCheck')
                                            }}
                                        >
                                            <div className="pound">
                                                &pound;
                                            </div>
                                            <input
                                                name="commonArea"
                                                disabled={!get(values, 'commonAreaCheck', false)}
                                                onChange={
                                                    (event) => {
                                                        const commonValue = event.target.value.replace(/[^0-9]/g, '')
                                                        this.handleChangeCustom(
                                                            Number(commonValue), 'commonArea')
                                                    }
                                                }
                                                placeholder="0"
                                                type="text"
                                                min="0"
                                                step="any"
                                                value={Number(get(values, 'commonArea', 0)).toLocaleString('en-GB')}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="item-col-2 item-col-2__w58 bottom-line">
                                    <div className="col1 col1__checkbox">
                                        <Checkbox
                                            last={true}
                                            first={true}
                                            short={true}
                                            name="commercialLossRentCheck"
                                            selected={get(values, 'commercialLossRentCheck', false)}
                                            onChange={this.handleChangeCustom}
                                        >
                                            Commercial loss of rent
                                        </Checkbox>
                                    </div>
                                    <div className="col2">
                                        <div
                                            className={`input 
                                                ${get(values, 'commercialLossRentCheck', false) ? '' : 'disabled'}`}
                                            onClick={() => {
                                                this.handleChangeCustom(true, 'commercialLossRentCheck')
                                            }}
                                        >
                                            <div className="pound">
                                                &pound;
                                            </div>
                                            <input
                                                name="commercialLossRent"
                                                disabled={!get(values, 'commercialLossRentCheck', false)}
                                                onChange={
                                                    (event) => {
                                                        const commercialLossValue =
                                                            event.target.value.replace(/[^0-9]/g, '')
                                                        this.handleChangeCustom(
                                                            Number(commercialLossValue), 'commercialLossRent')
                                                    }
                                                }
                                                placeholder="0"
                                                type="text"
                                                min="0"
                                                step="any"
                                                value={
                                                    Number(get(values, 'commercialLossRent', 0)).toLocaleString('en-GB')
                                                }
                                            />
                                        </div>
                                        {get(values, 'commercialLossRentCheck', false) && (
                                            <div className="indemnity_dropdown">
                                                <EnhancedComponent
                                                    itemList={monthOptions}
                                                    name="commercialLossRentMonth"
                                                    setFieldValue={this.handleChange}
                                                    check={true}
                                                    active={true}
                                                    label="Commercial loss of rent indemnity period"
                                                    selected={
                                                        this.getSelectedValue(monthOptions, 'commercialLossRentMonth')}
                                                />
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="extra_cover_sec">
                            <div className="extra_cover_group">
                                <div
                                    className={`item-col-2 
                                    item-col-2__${get(values, 'interestedPartiesCheck', false) === true ?
                                            'w95 bottom-line interested_parties_input' : 'w58'}`}
                                >
                                    <div className="col1 col1__checkbox">
                                        <Checkbox
                                            last={true}
                                            first={true}
                                            short={true}
                                            name="interestedPartiesCheck"
                                            selected={get(values, 'interestedPartiesCheck', false)}
                                            onChange={this.handleChangeCustom}
                                        >
                                            Interested parties
                                        </Checkbox>
                                    </div>
                                    {get(values, 'interestedPartiesCheck', false) === true && (
                                        <div>
                                            <div className="nameof_interest">
                                                <label className="p-10">Name of interested parties</label>
                                            </div>
                                            <div className="input">
                                                <input
                                                    name="interestedParties"
                                                    id="interestedParties"
                                                    type="text"
                                                    placeholder="Type Here ..."
                                                    onChange={
                                                        (event) => {
                                                            this.handleChangeCustom(
                                                                (event.target.value), 'interestedParties')
                                                        }
                                                    }
                                                    value={get(values, 'interestedParties', '')}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="addressBlock__actions">

                        <Button
                            half={true}
                            type="button"
                            onClick={this.handleCancel}
                        >
                            Cancel
                        </Button>
                        <Button
                            half={true}
                            type="submit"
                            disabled={!this.props.isValid}
                        >
                            Confirm property details
                        </Button>

                    </div>

                </form>
            </div>
        )
    }
}

/**
 *     Formik Validation Struture
 */
const AddressSecurity = withFormik<any, any>({

    mapPropsToValues: (props: any) => ({
        'goodState': get(props.propertyData, 'goodState', false),
        'notUndergo': get(props.propertyData, 'notUndergo', false),
        'notUniccupied': get(props.propertyData, 'notUniccupied', false),
        'subsidence': get(props.propertyData, 'subsidence', false),
        'sufferedFlooding': get(props.propertyData, 'sufferedFlooding', false),
        'hmo': get(props.propertyData, 'hmo', false),
        'brickStoneConcrete': get(props.propertyData, 'brickStoneConcrete', false),
        'notBuiltRoofSlateTileMetal': get(props.propertyData, 'notBuiltRoofSlateTileMetal', false),
        'heatedBy': get(props.propertyData, 'heatedBy', false),
        'contentsOnly': get(props.propertyData, 'contentsOnly', false),
        'declared': get(props.propertyData, 'declared', 0),
        'listed': get(props.propertyData, 'listed', ''),
        'basementUse': get(props.propertyData, 'basementUse', ''),
        'totalFloorBasement': Number(get(props.propertyData, 'totalFloorBasement', 0)),
        'concreteFloors': Number(get(props.propertyData, 'concreteFloors', 0)),
        'timberFloors': Number(get(props.propertyData, 'timberFloors', 0)),
        'percentageOfFlatRoof': get(props.propertyData, 'percentageOfFlatRoof', ''),
        'constructionFlatRoof': get(props.propertyData, 'constructionFlatRoof', ''),
        'yearOfBuild': get(props.propertyData, 'yearOfBuild', ''),
        'propertyType': get(props.propertyData, 'propertyType', ''),
        'residentialOccupancy': get(props.propertyData, 'residentialOccupancy', ''),
        'commercialOccupancy': get(props.propertyData, 'commercialOccupancy', ''),
        'noOfFlats': get(props.propertyData, 'noOfFlats', ''),
        'commercialLossRentCheck': get(props.propertyData, 'commercialLossRent', 0) > 0 ? true : false,
        'commercialLossRentMonth': get(props.propertyData, 'commercialLossRentMonth', 0),
        'commercialLossRent': get(props.propertyData, 'commercialLossRent', 0),
        'landLordCheck': get(props.propertyData, 'landLord', 0) > 0 ? true : false,
        'landLord': get(props.propertyData, 'landLord', 0),
        'commonAreaCheck': get(props.propertyData, 'commonArea', 0) > 0 ? true : false,
        'commonArea': get(props.propertyData, 'commonArea', 0),
        'increasedMdTenantLimitCheck': get(props.propertyData, 'increasedMdTenantLimitCheck', false),
        'increasedMdTenantLimit': get(props.propertyData, 'increasedMdTenantLimit', ''),
        'interestedPartiesCheck': get(props.propertyData, 'interestedParties', '') ? true : false,
        'interestedParties': get(props.propertyData, 'interestedParties', ''),
    }),

    validateOnChange: true,
    validateOnBlur: true,

    validationSchema: Yup.object().shape({
        'goodState': Yup.boolean().required('This is required'),
        'notUniccupied': Yup.boolean().required('This is required'),
        'totalFloorBasement': Yup.number()
            .min(1, 'Number of floors is required and must be greater than 0')
            .required('Number of floors is required and must be greater than 0'),
        'percentageOfFlatRoof': Yup.number(),
        'constructionFlatRoof': Yup.string().when('percentageOfFlatRoof', {
            is: (value) => value > 0,
            then: Yup.string().required('Required when percentage > 0'),
        }),
        'yearOfBuild': Yup.string().required('This is required'),
        'contentsOnly': Yup.boolean(),
        'declared': Yup.number().when('contentsOnly', {
            is: false,
            then: Yup.number().required('Declared Value is required when Content Only is false')
                .test('Declared value must be greater than 0', value => value > 0),
            otherwise: Yup.number().nullable(),
        }),
        'landLord': Yup.number().when('contentsOnly', {
            is: true,
            then: Yup.number().required('Landlord is required when Content Only is true')
                .test('Declared value must be greater than 0', value => value > 0),
            otherwise: Yup.number().nullable(),
        }),
        'propertyType': Yup.string().required('This is required'),
        'bothOccupancy': Yup.boolean(),
        residentialOccupancy: Yup.string().when('bothOccupancy', {
            is: true,
            then: Yup.string().required('Residential occupancy is required when bothOccupancy is true'),
            otherwise: Yup.string().nullable(),
        }),
        commercialOccupancy: Yup.string().when('bothOccupancy', {
            is: true,
            then: Yup.string().required('Commercial occupancy is required when bothOccupancy is true'),
            otherwise: Yup.string().nullable(),
        }),
        'validateOccupancy': Yup.string().test(
            function () {
                const { residentialOccupancy, commercialOccupancy } = this.parent
                return residentialOccupancy || commercialOccupancy
            }
        ),
        'sumOfConcreteWood': Yup.string().test(
            'sum-match',
            'The sum of concrete and timber floors must be equal to the total number of floors',
            function () {
                const { totalFloorBasement, concreteFloors, timberFloors } = this.parent
                if (totalFloorBasement) {
                    return Number(concreteFloors) + Number(timberFloors) === Number(totalFloorBasement)
                }
                return true
            }
        ),
    }),

    handleSubmit: (values, { props, setSubmitting }) => {
        if (!props.addressId && !props.initial_address) {

            let body = {
                'riskLocation': {
                    'addressType': props.address.riskLocation.addressType,
                    'addressLine1': props.address.riskLocation.addressLine1,
                    'addressLine2': props.address.riskLocation.addressLine2,
                    'lat': props.address.riskLocation.lat,
                    'lng': props.address.riskLocation.lng,
                    'city': props.address.riskLocation.city,
                    'postcode': props.address.riskLocation.postcode,
                    'countryId': props.address.riskLocation.countryId,
                    'securityVerified': true,
                    'goodState': values.goodState,
                    'notUndergo': values.notUndergo,
                    'notUniccupied': values.notUniccupied,
                    'subsidence': values.subsidence,
                    'sufferedFlooding': values.sufferedFlooding,
                    'hmo': values.hmo,
                    'brickStoneConcrete': values.brickStoneConcrete,
                    'notBuiltRoofSlateTileMetal': values.notBuiltRoofSlateTileMetal,
                    'heatedBy': values.heatedBy,
                    'contentsOnly': values.contentsOnly ? values.contentsOnly : false,
                    'declared': values.declared ? values.declared : Number(0),
                    'listed': values.listed ? values.listed : '',
                    'basementUse': values.basementUse ? values.basementUse : '',
                    'totalFloorBasement': values.totalFloorBasement ? values.totalFloorBasement : Number(0),
                    'concreteFloors': values.concreteFloors ? values.concreteFloors : Number(0),
                    'timberFloors': values.timberFloors ? values.timberFloors : Number(0),
                    'percentageOfFlatRoof': values.percentageOfFlatRoof ? values.percentageOfFlatRoof : '',
                    'constructionFlatRoof': values.constructionFlatRoof ? values.constructionFlatRoof : '',
                    'yearOfBuild': values.yearOfBuild ? values.yearOfBuild : '',
                    'propertyType': values.propertyType ? values.propertyType : '',
                    'residentialOccupancy': values.residentialOccupancy ? values.residentialOccupancy : '',
                    'commercialOccupancy': values.commercialOccupancy ? values.commercialOccupancy : '',
                    'noOfFlats': values.noOfFlats ? values.noOfFlats : '',
                    'commercialLossRentMonth': values.commercialLossRentCheck ? values.commercialLossRentMonth : '',
                    'commercialLossRent': values.commercialLossRentCheck ? values.commercialLossRent : Number(0),
                    'landLord': values.landLordCheck ? values.landLord : Number(0),
                    'commonArea': values.commonAreaCheck ? values.commonArea : Number(0),
                    'increasedMdTenantLimit': values.increasedMdTenantLimitCheck ?
                        values.increasedMdTenantLimit : Number(0),
                    'interestedParties': values.interestedPartiesCheck ? values.interestedParties : '',
                },
            }

            props.handleNewAddress(body)
            props.handleCancel(false)

        } else {

            let body = {
                'riskLocation': {
                    // 'id': props.addressId,
                    // 'quoteId': props.quoteId,
                    'securityVerified': true,
                    'goodState': values.goodState,
                    'notUndergo': values.notUndergo,
                    'notUniccupied': values.notUniccupied,
                    'subsidence': values.subsidence,
                    'sufferedFlooding': values.sufferedFlooding,
                    'hmo': values.hmo,
                    'brickStoneConcrete': values.brickStoneConcrete,
                    'notBuiltRoofSlateTileMetal': values.notBuiltRoofSlateTileMetal,
                    'heatedBy': values.heatedBy,
                    'contentsOnly': values.contentsOnly ? values.contentsOnly : false,
                    'declared': values.declared ? values.declared : Number(0),
                    'listed': values.listed ? values.listed : '',
                    'basementUse': values.basementUse ? values.basementUse : '',
                    'totalFloorBasement': values.totalFloorBasement ? values.totalFloorBasement : Number(0),
                    'concreteFloors': values.concreteFloors ? values.concreteFloors : Number(0),
                    'timberFloors': values.timberFloors ? values.timberFloors : Number(0),
                    'percentageOfFlatRoof': values.percentageOfFlatRoof ? values.percentageOfFlatRoof : '',
                    'constructionFlatRoof': values.constructionFlatRoof ? values.constructionFlatRoof : '',
                    'yearOfBuild': values.yearOfBuild ? values.yearOfBuild : Number(0),
                    'propertyType': values.propertyType ? values.propertyType : '',
                    'residentialOccupancy': values.residentialOccupancy ? values.residentialOccupancy : '',
                    'commercialOccupancy': values.commercialOccupancy ? values.commercialOccupancy : '',
                    'noOfFlats': values.noOfFlats ? values.noOfFlats : '',
                    'commercialLossRentMonth': values.commercialLossRentCheck ? values.commercialLossRentMonth : '',
                    'commercialLossRent': values.commercialLossRentCheck ? values.commercialLossRent : Number(0),
                    'landLord': values.landLordCheck ? values.landLord : Number(0),
                    'commonArea': values.commonAreaCheck ? values.commonArea : Number(0),
                    'increasedMdTenantLimit': values.increasedMdTenantLimitCheck ?
                        values.increasedMdTenantLimit : Number(0),
                    'interestedParties': values.interestedPartiesCheck ? values.interestedParties : '',
                },
            }

            props.addLocationsSecurity(props.quoteId, props.temp_id, body)
            props.handleCancel(false)
        }
    },

})(AddressSecurityForm)

export default AddressSecurity



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/components/Step02cp/components/AddressSecurity.tsx